/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";

import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";
import {
    FEEDBACK_BUTTON,
    PRODUCT,
    PRODUCT_IMG,
    MODAL_FEEDBACK_CARD,
    PROMO_BUTTON,
    PROVENANCE,
} from "./config/product-view";
import { VIDEO, THUMB_NAIL } from "../assets/images";
import blueprint from "./config/product-page.json";

const SERVICE_NAME = "product-view-rest.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class ProductViewRestService {
    name = SERVICE_NAME;
    private static instance: ProductViewRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ProductViewRestService(props);
        }
        return this.instance;
    }
    async init() {}

    _getImages(images: any, videos: any, videoURL: string) {
        let resultImg: any[] = [];

        videoURL &&
            resultImg.push({
                original: THUMB_NAIL,
                thumbnail: THUMB_NAIL,
                thumbnailHeight: "100",
                thumbnailClass: "image-thumb",
                type: "video",
                embedUrl: videoURL,
            });

        // let _videos = [
        //     {src: "https://s3.ap-south-1.amazonaws.com/io.vlinder.trainings/Backend_Architecture_By_Kiran/filename.m3u8"}
        // ]

        // var src = videoURL; ///video url not youtube or vimeo,just video on server
        // var video = document.createElement("video");

        // video.src = src;

        // video.width = 360;
        // video.height = 240;

        // var canvas = document.createElement("canvas");
        // canvas.width = 360;
        // canvas.height = 240;
        // var context = canvas.getContext("2d");

        //     context.drawImage(video, 30, 30, canvas.width, canvas.height);
        //     var dataURI = canvas.toDataURL("image/jpeg");
        //     console.log(`thumbnail:`, dataURI);

        videos &&
            Array.isArray(videos) &&
            videos.forEach((item: any, index: number) => {
                if (item?.src)
                    resultImg.push({
                        original: THUMB_NAIL,
                        thumbnail: THUMB_NAIL,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                        type: "video",
                        embedUrl: item?.src,
                    });
            });

        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item)
                    resultImg.push({
                        original: item,
                        thumbnail: item,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                        type: "image",
                    });
            });

        return resultImg;
    }

    async productview() {
        //log.info(`in productView service.`, id, trinetr);
        try {
            let res: any;
            // if (trinetr) {
            //     res = await this.api.post(
            //         "/provenance/full_provenance/no_auth/",
            //         {
            //             barcode: id,
            //             appMode: "web",
            //             scanType: "barcode",
            //             fssai: trinetr?.fssaiNO.trim(),
            //             mfgDate: trinetr?.mfd, //"08.04.2022",
            //             batch: trinetr?.batch //"03"
            //         }
            //     );
            // } else {
            //     res = await this.api.post(
            //         "/provenance/full_provenance/no_auth/",
            //         {
            //             barcode: id,
            //             appMode: "web",
            //             scanType: "barcode",
            //         }
            //     );
            // }
            // if (res) {
                //let _data = res?.data?.data;
                let _data = blueprint?.product_data
                log.success(`provenance Data:`, _data);
                if (_data)
                    return {
                        v2ProvData: _data,
                        FEEDBACK_BUTTON: _data?.FeedbackButton,
                        PRODUCT: {
                            ...{ ..._data?.product },
                        },
                        PRODUCT_IMG: this._getImages(
                            _data?.product?.images,
                            _data?.product?.videos,
                            _data?.batch?.promoVideoUrl
                        ),
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        PROMO_BUTTON: {
                            ...{ ...PROMO_BUTTON },
                            url: _data?.product?.webUrl,
                        },
                        PROVENANCE: {
                            ...{ ..._data?.provenance },
                        },
                        ALL_PROV_STEP_MAP: _data?.allProvStepMap,
                        GTIN: _data?.product?.gtin,
                        // BATCH: _data?.product?.batch,
                        BATCH: {
                            ..._data?.batch,
                            // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo"
                        },
                        isAgeVerReq: _data?.others?.isAgeVerReq,
                    };
            //}
        } catch (err) {}
    }

    _getMeta = (data: any[]) => {
        let res =
            data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data.map((item: any, index: number) => {
                return {
                    key: item?.label,
                    value: item?.value,
                };
            });
        return res;
    };

    _getPrimaryMeta = (data: any[], productData: any) => {
        /*
         {
                    key: productData?.priceKey,
                    value: productData?.priceValue,
                },
                {
                    key: productData?.qtyKey,
                    value: productData?.qtyValue,
                },
                {
                    key: "Batch",
                    value: productData?.batch,
                },
                {
                    key: productData?.serialKey,
                    value: productData?.serialValue,
                },
                */
        let res: any[] =
            data && Array.isArray(data) && data.length > 0
                ? data.map((item: any, index: number) => {
                      return {
                          key: item?.label,
                          value: item?.value,
                      };
                  })
                : [];
        productData?.priceValue &&
            res.push({
                key: productData?.priceKey,
                value: productData?.priceValue,
            });
        productData?.qtyValue &&
            res.push({
                key: productData?.qtyKey,
                value: productData?.qtyValue,
            });
        productData?.batch &&
            productData?.batch.toLowerCase() !== "default" &&
            res.push({
                key: "Batch",
                value: productData?.batch,
            });
        productData?.serialValue &&
            res.push({
                key: productData?.serialKey,
                value: productData?.serialValue,
            });
        return res;
    };

    _productData = (productData: any, batch: any, detailsData: any) => {
        let _meta: any = this._getPrimaryMeta(
            detailsData?.ProductDetailInfo?.productInfoList,
            productData
        );
        let _secondaryMeta: any = this._getMeta(
            detailsData?.OrganizationInfo?.organizationInfoList
        );
        let _actions: any[] = [
            // {
            //     key: "provenance",
            //     title: "Provenance Journey",
            // },
            {
                key: "feedback",
                title: batch?.promoButtonText1
                    ? batch?.promoButtonText1
                    : "Feedback",
                icon: "https://i.ibb.co/fSSyP77/icons8-feedback-24.png"
            },
            {
                key: "visit",
                title: batch?.promoButtonText2
                    ? batch?.promoButtonText2
                    : "Visit",
                url: batch?.promoWebsiteUrl,
                icon: "https://i.ibb.co/DbMbJXq/icons8-website-50.png"
            },
            // {
            //     key: "details",
            //     title: "View Proof of Authenticity",
            // },
        ];
        // batch && batch?.promoVideoUrl
        //     ? [
        //           {
        //               key: "provenance",
        //               title: "Provenance Journey",
        //           },
        //           {
        //               key: "feedback",
        //               title: batch?.promoButtonText1,
        //           },
        //           {
        //               key: "visit",
        //               title: batch?.promoButtonText2,
        //               url: batch?.promoWebsiteUrl,
        //           },
        //           {
        //               key: "video",
        //               title: "Watch Video",
        //               url: batch?.promoVideoUrl,
        //           },
        //           // {
        //           //     key: "details",
        //           //     title: "View Proof of Authenticity",
        //           // },
        //       ]
        //     : [
        //           {
        //               key: "provenance",
        //               title: "Provenance Journey",
        //           },
        //           {
        //               key: "feedback",
        //               title: batch?.promoButtonText1
        //                   ? batch?.promoButtonText1
        //                   : "Feedback",
        //           },
        //           {
        //               key: "visit",
        //               title: batch?.promoButtonText2
        //                   ? batch?.promoButtonText2
        //                   : "Visit",
        //               url: batch?.promoWebsiteUrl,
        //           },
        //           // {
        //           //     key: "details",
        //           //     title: "View Proof of Authenticity",
        //           // },
        //       ];
        return {
            idx: "1",
            title: productData?.title,
            subtitle: productData?.subtitle,
            secondaryTitle: detailsData?.OrganizationInfo?.title,
            promoVideoUrl: {
                url: batch?.promoVideoUrl,
                // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo",
            },
            serialNo: "Rare #/1",
            img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            tag: "DIAMOND",
            productCategory: "collectibles",
            category: "diamond",
            price: [
                {
                    type: "price",
                    amount: productData?.priceValue,
                },
            ],
            createdBy: {
                userName: detailsData?.OrganizationInfo?.aboutOrgInfo,
                userId: detailsData?.OrganizationInfo?.aboutOrgInfo,
                link: "https://www.diageoindia.com/",
                authProofUrl: "",
            },
            meta: [..._meta],
            secondaryMeta: [..._secondaryMeta],

            actions: _actions,
            images: this._getImages(
                productData?.images,
                productData?.videos,
                batch?.promoVideoUrl
            ),
        };
    };

    async productDetailView() {
        try {
            // const res = await this.api.post(
            //     "/provenance/product_cred/no_auth/",
            //     {
            //         gtin: payload?.gtin,
            //     }
            // );
            // if (res) {
               // let _detailsData = res?.data?.data?.productDetails;
               let _detailsData = blueprint?.product_detail?.data?.productDetails
                //let _data = payload?.v2ProvData;
                let _data = blueprint?.product_data
                log.blue(`v2ProvData`,_data ,_detailsData);
                let firstProv =
                    _data?.provenance?.data &&
                    Array.isArray(_data?.provenance?.data) &&
                    _data?.provenance?.data.length > 0 &&
                    _data?.provenance?.data[0];
                firstProv =
                    firstProv?.data &&
                    Array.isArray(firstProv?.data) &&
                    firstProv?.data.length > 0 &&
                    firstProv?.data[0];
                if (_data)
                    return {
                        // pagination: {
                        //     nextOffset: offset + _found.length,
                        //     totalItems: TEST_DATA?.length,
                        // },
                        ...blueprint?.product_detail?.data,
                        ...this._productData(
                            _data?.product,
                            _data?.batch,
                            _detailsData
                        ),
                        firstProv: firstProv,
                        MODAL_FEEDBACK_CARD: {
                            ...{ ..._data?.feedbackModal },
                        },
                        GTIN: _data?.product?.gtin,
                        BATCH: {
                            ..._data?.batch,
                            // url: "https://www.youtube.com/watch?v=Ct6-ZK0Z9mo"
                        },
                        FEEDBACK_BUTTON: _data?.FeedbackButton,
                        PRODUCT: {
                            ...{ ..._data?.product },
                        },
                        PRODUCT_IMG: this._getImages(
                            _data?.product?.images,
                            _data?.product?.videos,
                            _data?.batch?.promoVideoUrl
                        ),
                        PROMO_BUTTON: {
                            ...{ ...PROMO_BUTTON },
                            url: _data?.product?.webUrl,
                        },
                        PROVENANCE: {
                            ...{ ..._data?.provenance },
                        },
                        ALL_PROV_STEP_MAP: _data?.allProvStepMap,
                        isAgeVerReq: _data?.others?.isAgeVerReq,
                    };
                // if (_data)
                //     return {
                //         PRODUCT_IMG: this._getImages(
                //             _data?.ProductImages?.productImages
                //         ),
                //         ORGANIZATION_INFO: _data?.OrganizationInfo,
                //         PRODUCT_DETAIL_INFO: _data?.ProductDetailInfo,
                //         PRODUCT_TITLE_CARD: _data?.ProductTitleCard
                //     };
            //}
            // let _data = {
            //     PRODUCT_IMG,
            //     ORGANIZATION_INFO,
            //     PRODUCT_DETAIL_INFO,
            //     PRODUCT_TITLE_CARD,
            // };
            // return _data;
        } catch (err) {}
    }

    async productTos(payload: any) {
        try {
            const res = await this.api.post("/vlinder-core/tos/no_auth", {
                gtin: payload?.gtin,
                action: "age_verification",
                service_agreement: "test aggrement",
            });
            if (res) {
                let _data = res?.data?.data;
                return _data;
            }
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
